// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"G1-z"};